module.exports = __webpack_public_path__ + "static/satellite_map-eef73b810a3348ac8b05f3f7a4f41c50.png";